export default __webpack_public_path__ + "static/media/camera.ed6cda29.svg";